module.exports = __webpack_public_path__ + "static/media/keyholeMessageDoorLocked.a358ddb1.png";